module.exports = __webpack_public_path__ + "img/palmar-hotel4.34d85393.jpg";